<template style="height: 100%;">
  <div class="Scblock CommonContentSingle-white">
    <div class="acc">

      <el-row>
        <el-button style="margin-top: 15px" type="primary" @click="gou_url"> {{ $t('original.begin_testing') }}</el-button>
        <!-- <el-button style="margin-top: 15px" type="primary" @click="gou_url21"> 跳转测试</el-button>
        <el-button style="margin-top: 15px" type="primary" @click="gou_url2122"> 跳转测试2</el-button>
        <el-button style="margin-top: 15px" type="primary" @click="gou_url2133"> 跳转测试2</el-button> -->
        <el-button style="margin-top: 15px" class="search_btn" @click="sousuo" type="primary">
           {{ $t('original.search') }}
        </el-button>
        <el-input style="margin-top: 13px" class="search" v-model="Tiaojian" :placeholder="$t('original.languages65')"
          prefix-icon="el-icon-search" :clearable="true" @clear="removeall"></el-input>
      </el-row>

    </div>
    <div class="Scblock_ts" style="border:1px solid #e3e3e3;">
      <h2 style="margin-left:20px;"> {{ $t('original.Inventory_classification') }} </h2>
      <h3 style="margin-left:40px;"> {{ $t('original.Inventory_list') }} </h3>
    </div>
    <el-tabs :tab-position="tabPosition" style="height: calc(100% - 104px);text-align: left !important;overflow: auto;border: 1px solid #e3e3e3;"  class="allpaper">
      <el-tab-pane v-for="item in scalelist" :key="item.message" :label="item.PaperName" style="height:100%;">
        <div class="Scblock_ts_s" style="height: 50px;line-height:50px;">
          <!--<h2>{{$t('original.choose')}}</h2> -->
          <h3 style="margin-left:40px">{{$t('original.Name_of_scale')}}</h3>
          <h4 style="margin-left:40px">{{$t('original.Scale_description')}}</h4>
          <!-- <h4 style="float: right;margin-right:40px;">测试用时</h4> -->
        </div>
        
        <ul class="dvdvvd" style="">

          <li v-for="(item, index) in item.LiPaper" :key="index">
            <div class="SCL">
              <el-checkbox-group v-model="checkList" size="small" @change="setMea0lSelect">
                <el-checkbox :label="item.PaperCode" :name="item.PaperName" :title="item.PaperName">
                  {{ item.PaperName }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="describe" v-html="item.Introduction.replace('<br/>', '')" :title="item.Introduction.replace('<br/>', '')">
            </div>
            <!-- <div style="float: right;margin-top: -80px;margin-right: 20px;color: rgb(112, 112, 112);border-left: 1px solid #e3e3e3;height: 80px;line-height: 80px;width: 100px;text-indent: 17px;" v-html="item.testTimes"> </div> -->
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      checkList: [],//只能选中一个的数组
      tabPosition: "left",
      scalelist: "",
      Tiaojian: "",
      jsonArray: [],
      checkboxGroup1: [],
      checkboxGroup2: [],
      numbers: "0",
    };
  },
  beforeCreate() {
    this.$Http_Post("ScaleIssue/GetShowScale",{Tiaojian: ""}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.scalelist = res.Data;
      }
    });
  },
  methods: {
    gou_url21(){
      this.$router.push({path: "/measurement/Interview_brief"});
    },
    gou_url2122(){
      this.$router.push({path: "/measurement/Health_report"});
    },
    gou_url2133(){
      this.$router.push({path: "/measurement/Mental_health_report"});
    },
    setMealSelect() {
      //截取数组的最后一位,并从新赋值
      this.checkList = this.checkList.slice(-1);
    },
    gou_url() {
      if (this.checkList.length == 0) {
        this.Global.request_failure(this.$t('original.languages66'));
        return;
      }
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      if (this.checkList[0] === "EPQA" && year - moment(this.Global.birthday).year() < 16) {
        //成人版
        this.$message({
          type: "error",
          message: this.$t('original.languages67'),
        });
        return;
      }

      if (this.checkList[0] === "（EPQC）" && year - moment(this.Global.birthday).year() > 15) {
        //少年版
        this.$message({
          type: "error",
          message: this.$t('original.languages68'),
        });
        return;
      }

      if (this.checkList[0] === "WAIS-RC_KJ") {
        this.$router.push({path: "/measurement/",query: { PaperID: this.checkList[0], PublishID: "0", type: 4 }});
      } else if (this.checkList[0] === "WAIS-RC") {
        this.$router.push({path: "/measurement/PaperTest_WebsterMemory",query: { PaperID: this.checkList[0], PublishID: "0", type: 4}});
      } else {
        this.$router.push({path: "/measurement/PaperTest",query: { PaperID: this.checkList[0], PublishID: "0", type: 4}});
      }

    },
    sousuo() {
      this.$Http_Post("ScaleIssue/GetShowScale", {Tiaojian: this.Tiaojian}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (res.Data.length <= 0) {
            this.Global.request_failure("暂无相关量表！");
          } else {
            this.scalelist = res.Data;
          }
        }
      });
    },
    removeall() {
      this.$Http_Post("ScaleIssue/GetShowScale", { Tiaojian: "" }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.scalelist = res.Data;
          }
        }
      );
    },
  },
};
</script>
<style>
.Scblock .acc {width:100%;height:60px;background-color:#fff;z-index:9999;}
.Scblock>ul {position: relative;min-height: 650px;background-color: chocolate;height: 100%;}
.Scblock>ul>li {height: 50px;line-height: 50px;color: rgba(61, 61, 61, 1);cursor: pointer;}
.Scblock>ul>li>ul>li {background-color: chartreuse;width: 90%;min-height: 650px;position: absolute;top: 0px;right: 0px;position: relative;}
.is-left {text-align: left;}
.Scblock .el-tabs--left .el-tabs__item.is-left {text-align: left !important;font-size: 14px;}
.allpaper .el-tabs__content {height: 100% !important;overflow-y: auto;}
.Scblock_ts {width: calc(100% - 2px);height: 40px;line-height: 40px;}
.Scblock_ts h2   {width: 117px;display: inline-block;font-size: 16px;border-right: 1px solid #e3e3e3;}
.Scblock_ts h3   {width: 160px;display: inline-block;font-size: 16px;}
.Scblock_ts_s h2 {width: 60px;display: inline-block; font-size: 16px;margin-left: 28px;}
.Scblock_ts_s h3 {width: 275px;display: inline-block;font-size: 16px;}
.Scblock_ts_s h4 {display: inline-block;font-size: 16px;}
.describe {padding: 20px 32px;border-left: #e3e3e3 1px solid;display: inline-block;max-width: 60%;line-height: 30px;margin-left: 325px;color: rgba(112, 112, 112, 1);overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;height: 47px;margin-top: -10px;}
.dvdvvd {border: 1px solid #e3e3e3;height: calc(100% - 52px);overflow: auto;}
.dvdvvd::-webkit-scrollbar {height: 0;width: 0;}
.dvdvvd li { position: relative; border-bottom: 1px solid #e3e3e3;}
.SCL {margin-top: 20px;width: 300px;display: inline-block;position: absolute;top: 20px;left: 20px;}
.el-tabs--left .el-tabs__active-bar.is-left,
.el-tabs--left .el-tabs__nav-wrap.is-left::after {right: 0px;left: 0px;width: 2px;}
.Scblock .el-input {width: 20%;float: right;}
.Scblock .search_btn {float: right;}
.Scblock .SCL {margin-top: 18px;}
.Scblock .el-checkbox__label {width: 240px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.Scblock .el-checkbox__input {margin-top: -8px;}
.Scblock .el-tabs__nav-scroll {max-height: 580px;overflow: auto;}
.Scblock .el-tabs__nav-scroll::-webkit-scrollbar {height: 0;width: 0;}
.Scblock .el-tabs--left .el-tabs__header.is-left{border: 1px solid #e3e3e3;height: calc(100% - 2px);margin-right:0px;border-left: 0px;}
</style>
